<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box no-display">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Leaving Certificate </strong>
                    <v-icon @click="onload" title="Reload list" dark color="yellow">mdi-reload</v-icon>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4" class="mt-3">
                    <v-combobox class="no-display" v-model="registration_no" @change="checkHistory" :loading="comp_load"
                        rounded :items="stud_list" label="Select Student" item-text="name" outlined dense
                        prepend-icon="mdi-account-child-circle"></v-combobox>
                </v-col>
            </v-row>
            <div v-if="registration_no != null">
                <template>
                    <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="panelheader">Account History
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-5">
                                <v-data-table :headers="headers_1" :items="ay_record" class="elevation-1 mytable" dense>
                                    <template v-slot:item.status="{ item }">
                                        <v-chip :color="getColor(item.status)" dark>
                                            {{ item.status }}
                                        </v-chip>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-expansion-panels class="expapanel no-display" focusable inset>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="panelheader">Academic History
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-5">
                                <!-- table content -->

                                <v-data-table :headers="headers_2" :items="ay_record_div" dense
                                    class="elevation-1 mytable">
                                </v-data-table>
                                <!-- table end -->
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </template>

                <!-- radio button -->
                <v-row justify="center" dense class="no-display">
                    <v-radio-group v-model="fetch_gen_toggle" mandatory row class="radiobtn">
                        <v-radio label="Fetch LC" value="FETCH"></v-radio>
                        <v-radio label="Generate LC" value="GENERATE"></v-radio>
                    </v-radio-group>
                </v-row>
                <!-- radio button end -->
                <v-row justify="center" v-if="ay_record.length != 0">
                    <div class="fees no-display">
                        <span v-if="account_status" style="color: #4caf50">Fees Clear
                        </span>
                        <span v-else style="color: #f44336">Fees Pending</span>
                    </div>
                </v-row>
            </div>
            <div v-if="registration_no != null">
                <label>
                <input type="checkbox" v-model="isDuplicate" @change="updateCopyName">
                    Is Duplicate
                </label>
            </div>
        </v-card>
        <div v-if="registration_no != null">
            <!-- generate lc code -->
            <template v-if="fetch_gen_toggle == 'GENERATE'">
                <!-- Date starts -->
                <v-row justify="center" class="mt-3">
                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense v-model="last_date_of_school"
                                @blur="date = parseDate(last_date_of_school)" v-on="on" hint="Last Date of Leaving"
                                prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>

                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense v-model="gen_date" @blur="date = parseDate(gen_date)" v-on="on"
                                hint="Generation Date" prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>
                    <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-bind="attrs" dense v-model="application_date"
                                @blur="date = parseDate(application_date)" v-on="on" hint="Date Of Application"
                                prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date_of_application" no-title @input="menu4 = false"
                            @change="setToText()"></v-date-picker>
                    </v-menu>
                    <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-bind="attrs" dense v-model="issue_date" @blur="date = parseDate(issue_date)"
                                v-on="on" hint="Date Of Issue" prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker label="Issue Date" v-model="date_of_issue" no-title @input="menu3 = false"
                            @change="setToText2()"></v-date-picker>
                    </v-menu>
                </v-row>
                <v-row style="margin-left: 10px;" v-if="tenant === 'mkd'">
                    <v-col cols="12" sm="2" md="2" >
                        <v-text-field
                        type="text"
                        label="Enter Total Working Days"
                        v-model="total_working_days_sem"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field
                        type="text"
                        label="Enter Total Present Days"
                        v-model="student_present_days"
                        ></v-text-field>
              </v-col>
                </v-row>
                <!-- Date ends -->
                <v-row justify="center" class="mt-3">
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="progress" rounded :items="dvt_prog" label="Select Progress" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="conduct" rounded :items="dvt_conduct" label="Select Conduct" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="remark" rounded :items="dvt_remark" label="Select Remark" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="reason" rounded :items="dvt_reason" label="Select Reason" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                </v-row>
                <v-row justify="center" class="mt-3">
                    <v-checkbox color="#0f2027" v-model="mark_inactive"
                        label="Do You Want To Mark Student Inactive After Generating LC.?"></v-checkbox>
                </v-row>
                <v-row justify="center">
                    <v-btn class="button no-display" @click="genLC" :disabled="!condition">Generate LC</v-btn>
                </v-row>
            </template>
            <!-- generate lc code end -->
            <template v-if="fetch_gen_toggle == 'FETCH'">
                <v-row justify="center">
                    <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>
                </v-row>
            </template>
            <br>
        </div>
        <br>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            mark_inactive: false,
            headers_1: [
                { text: "Academic Year", value: "ay" },
                { text: "Paid", value: "paid" },
                { text: "Balance", value: "balance" },
                { text: "Status", value: "status" },
            ],
            headers_2: [
                { text: "Academic Year", value: "ay" },
                { text: "Roll No", value: "rollno" },
                { text: "Div", value: "div" },
                { text: "Std", value: "std" },
                { text: "Total", value: "total" },
                { text: "Present ", value: "present" },
            ],

            comp_load: false,
            fetch_loader: false,
            overlay: false,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            registration_no: null,
            stud_list: [],
            ay_record: [],
            ay_record_div: [],
            account_status: false,
            dvt_prog: [],
            progress: null,
            dvt_conduct: [],
            conduct: null,
            dvt_reason: [],
            reason: null,
            result_status: null,
            result_status_list: [
                { name: "Pass", id: 1 },
                { name: "Fail", id: 2 },
            ],
            student_result_status: false,
            dvt_remark: [],
            remark: null,
            fetch_gen_toggle: "FETCH",
            board_toggle: "SSC",
            //////date
            last_date_of_school: "",
            gen_date: "",
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            date_of_application: new Date().toISOString().substr(0, 10),
            date_of_issue: "",
            application_date: "",
            issue_date: "",
            menu1: false,
            menu2: false,
            menu3: false,
            menu4: false,
            nowDate: new Date().toISOString().slice(0, 10),
            ///
            lc_data: null,
            current_ay: null,
            org_basic_data: null,
            condition: false,
            org_id: null,
            isDuplicate: false,
            copy_name: "ORIGINAL",
            total_working_days_sem:"",
            student_present_days:"",
            tenant:""
        };
    },
    watch: {
        date(val) {
            this.last_date_of_school = this.formatDate(this.date);
        },
        date2(val) {
            this.gen_date = this.formatDate(this.date2);
        },
        date_of_application(val) {
            this.application_date = this.formatDate(this.date_of_application);
            this.lc_data.date_of_application = this.application_date;
        },
        date_of_issue(val) {
            this.issue_date = this.formatDate(this.date_of_issue);
            this.lc_data.date_of_issue = this.issue_date;
        },
    },
    methods: {
        updateCopyName() {
            this.copy_name = this.isDuplicate ? "DUPLICATE" : "ORIGINAL";
        },

        getMarathiValue(type, value) {
            const mappings = {
                // nationality: {
                //     "Indian": "भारतीय"
                // },
                gender: {
                    "Male": "पुरुष",
                    "Female": "स्त्री"
                },
                medium: {
                    "English": "इंग्रजी",
                    "Marathi": "मराठी"
                },
                mothertongue: {
                    "Marathi": "मराठी",
                    "Hindi": "हिंदी",
                    "English": "इंग्रजी"
                }
            }

            if (
                mappings[type] &&
                mappings[type][value]
            ) {
                return mappings[type][value];
            }

            return value;
        },
        setToText() {
            this.lc_data.date_of_application = this.application_date;
        },
        setToText2() {
            this.lc_data.date_of_issue = this.issue_date;
        },
        proceed() {
            localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
            localStorage.setItem("current_ay", this.current_ay);
            localStorage.setItem(
                "org_basic_data",
                JSON.stringify(this.org_basic_data)
            );
            let routeData = this.$router.resolve({ name: "print-lc-template" });
            window.open(routeData.href, "_blank");
        },

        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year}`;
        },
        getColor(status) {
            if (status === "pending") return "red";
            if (status === "clear") return "green";
            if (status === "NA") return "gray";
        },

        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        onload() {
            this.ay_record = [];
            this.lc_data = null;
            this.org_basic_data = null;
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.all_stud_list;
                    } else {
                        this.showSnackbar("red", "Something went wrong.");
                    }
                    this.comp_load = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.comp_load = false;
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        checkHistory() {
            console.log("registration_no:", this.registration_no);
            this.ay_record = [];
            this.lc_data = null;
            this.org_basic_data = null;
            if (this.registration_no == null) {
                this.showSnackbar("red", "Please select student");
            }
            this.overlay = true;
            axios
                .post("/certificate/checkHistory", this.registration_no)
                .then((res) => {
                    console.log("res", res.data);
                    if (res.data.flag == "YES") {
                        this.ay_record = res.data.ay_record;
                        this.account_status = res.data.account_status;
                        this.ay_record_div = res.data.ay_record_div;
                        this.dvt_prog = res.data.dvt_prog;
                        this.progress = this.dvt_prog[0];
                        this.dvt_conduct = res.data.dvt_conduct;
                        this.conduct = this.dvt_conduct[0];
                        this.dvt_reason = res.data.dvt_reason;
                        this.reason = this.dvt_reason[0];
                        this.dvt_remark = res.data.dvt_remark;
                        this.remark = this.dvt_remark[0];
                        this.condition = res.data.condition;
                        if (!this.condition)
                            this.showSnackbar("red", res.data.condition_msg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        genLC() {
            if (this.account_status == false) {
                if (
                    !confirm(
                        "Are You Sure You Want To generate LC as fees is pending...?"
                    )
                )
                    return;
            }
            if (
                this.progress != null &&
                this.conduct != null &&
                this.last_date_of_school != "" &&
                this.gen_date != "" &&
                this.remark != null &&
                this.reason != null &&
                this.application_date != ""                 
            ) {
                const formData = {
                    lid: this.registration_no.lid,
                    progress: this.progress,
                    conduct: this.conduct,
                    remark: this.remark,
                    reason: this.reason,
                    last_date_of_school: this.last_date_of_school,
                    gen_date: this.gen_date,
                    date_of_application: this.application_date,
                    date_of_issue: this.issue_date,
                    mark_inactive: this.mark_inactive,
                    total_working_days_sem : this.total_working_days_sem,
                    total_present_days: this.student_present_days
                };
                this.overlay = true;
                axios
                    .post("/certificate/genLC", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {

                            let routeData = this.$router.resolve({
                                name: "print-lc-template",
                                query: { lid: this.registration_no.lid , copy_name: this.copy_name}
                            });

                            window.open(routeData.href, "_blank");
                            this.total_working_days_sem="";
                            this.student_present_days="";

                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            } else {
                this.showSnackbar("red", "Please select/enter all data");
            }
        },
        fetchLC() {
            let routeData = this.$router.resolve({
                name: "print-lc-template",
                query: { lid: this.registration_no.lid , copy_name: this.copy_name}
            });

            window.open(routeData.href, "_blank");
        }
    },
    mounted() {
        localStorage.setItem("last_date_of_school", "");
        this.onload();
        this.last_date_of_school = this.formatDate(this.date);
        this.gen_date = this.formatDate(this.date2);
        this.application_date = this.formatDate(this.date_of_application);
        this.issue_date = this.formatDate(this.date_of_issue);
        this.org_id = localStorage.getItem("EPS-org-id");
        this.tenant = localStorage.getItem("EPS-tenant");
    },
};
</script>
<style scoped>
.data-table td.index-col {
    width: 4%;
    white-space: nowrap;
    text-align: center;
}

.dotted-line {
    border-bottom: 2px dotted #000;
    width: 100%;
}

.small-table td {
    border: 1px solid black;
    padding: 0;
    text-align: left;
}

.small-table {
    border: 1px solid black;
}

.small-table td:first-child {
    width: 50%;
}

.data-table td {
    border: 1px solid black;
    text-align: left;
}

.data-table {
    border: 1px solid black;
    text-align: left;
}

.scroll {
    overflow-x: scroll;
}

.mytable /deep/ thead th {
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
    background: #83a4d4;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #265fb1,
            #b6fbff);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #265fb1,
            #b6fbff);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

tr,
td,
th {
    /* border: 1px solid #ccc; */
    text-align: center;
    font-size: small;
}

tr,
tbody {
    font-size: small;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
}

.expapanel {
    width: 93%;
    margin-left: 3%;
}

.panelheader {
    /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
    color: white !important;
    background: #83a4d4;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #3792c7,
            #60e3eb,
            #a0dfe3);
    /* Chrome 10-25, Safari 5.1-6 */
    /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    font-size: 16px;
    background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}

.fees span {
    font-size: 23px;
    font-weight: 600;
}

/* lc data css */
.printdiv {
    height: auto;
    margin-left: 10%;
    margin-right: 10%;
    padding: 30px;
    /* border: 1px solid black; */
    background-color: white;
    font-weight: 500;
}

.header {
    margin: 6px;
}

.last-row {
    display: flex;
    justify-content: space-around;
    width: 100%;
    /* margin-bottom: -15px; */
}

.content {
    padding-bottom: 10px;
}

p {
    margin: 0;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    body,
    tr,
    th,
    td {
        font-size: x-large !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    p {
        font-size: 17px !important;
    }

    .printdiv {
        margin: 0;
        padding: 0;
    }

    .cbse {
        margin-left: -15px !important;
        width: 102%;
    }

    #document1 {
        position: absolute;
        margin-top: -63px;
        top: 0;
        /* left: 0;
    right: 0; */
        bottom: 0;
    }

    @page {
        size: A4;
        margin: none;
        padding-top: none;
        size: 11.5in 16.5in;
    }
}
</style>